import { render } from "./CourseSearchFilters.vue?vue&type=template&id=0b9cd0ec&ts=true"
import script from "./CourseSearchFilters.vue?vue&type=script&lang=ts"
export * from "./CourseSearchFilters.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__